import moment from "moment";
import { roundTimeSeconds } from "theme/utils/helpers";

import { DateRangePicker } from "../../react/utils/dateRangePicker/DateRangePicker";

import template from "./pWorkData.html";
import angular from "angular";

export function pWorkDataDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pWorkDataController,
    controllerAs: 'pWorkData',
    bindToController: true
  };

  return directive;
}

class pWorkDataController {
  constructor ($q, $scope, Auth, Stats, DownloadFile, $interval, Notes, Sort, $route, $translate, $filter, ConnectionQuality) {
    'ngInject';

    this.$q = $q;
    this.$scope = $scope;
    this.Auth = Auth;
    this.Stats = Stats;
    this.DownloadFile = DownloadFile;
    this.ConnectionQuality = ConnectionQuality;
    this.$interval = $interval;
    this.Notes = Notes;
    this.Sort = Sort;
    this.$route = $route;
    this.$translate = $translate;
    this.$filter = $filter;

    this.isInvalidDateEndChoice = false;
    this.isInvalidDateStartChoice = false;
    this.hasProjectsFlag = false;
    this.hasPartTimeVacationFlag = false;

    this.dateStartChoice = moment().format("YYYY-MM-DD");
    this.dateEndChoice = moment().format("YYYY-MM-DD");

    this.DateRangePicker = DateRangePicker;
    this.dateRangePickerProps = {
      defaultValue: [new Date(this.dateStartChoice), new Date(this.dateEndChoice)],
      onChange: (values) => this.updateDates(values)
    };

    this.reportedOvertimeCards = [
      {
        id: "reportedOvertime",
        tooltip: this.$translate.instant("WORK_DATA.TOOLTIP.REPORTED"),
        name: this.$translate.instant("WORK_DATA.REPORTED_OVERTIME")
      },
      {
        id: "acceptedOvertime",
        tooltip: this.$translate.instant("WORK_DATA.TOOLTIP.ACCEPTED"),
        name: this.$translate.instant("WORK_DATA.ACCEPTED_OVERTIME")
      },
      {
        id: "cumulatedOvertime",
        tooltip: this.$translate.instant("WORK_DATA.TOOLTIP.BALANCE"),
        name: this.$translate.instant("WORK_DATA.CUMULATED_OVERTIME")
      }
    ];

    this.init();

    this.hasProjectsAllowed = false;

    this.state = "loading";
    this.statePowerUser = 'loading';
    this.calendarGOTOButtonsState = "loading";

    this.dateToday = moment().format("YYYY-MM-DD");

    // ---------------- calendar
    this.today = moment();
    this.pickedDate = angular.copy(this.today);
    this.year = this.pickedDate.format("YYYY"); // use to display info
    this.monthName = this.pickedDate.format("MMMM"); // use to display info
    this.calendarDays = this.getDaysArray(this.pickedDate); // use to display days, this step only sketch days in month
    // ---------------------

    // --------------------- vacation
    this.internalProject = [];

    this.pickType = "0";
    this.vacationPercentage = 100;
    this.userPosition = {};
    this.vacationPositions = [0,0,0,0,0];
    this.newVacationValues = {
      from: "",
      to: ""
    };
    this.warningModalExceededTime = false;
    this.warningModalExceededTimeData = [];
    this.daysToSubmit = 0;

    this.weekdaysForSelectHours = {
      MONDAY: false,
      TUESDAY: false,
      WEDNESDAY: false,
      THURSDAY: false,
      FRIDAY: false,
    };

    this.$scope.$watch(() => this.newVacationValues.from, () => this.showDate());
    this.$scope.$watch(() => this.newVacationValues.to, () => this.showDate());
    this.$scope.$watch(() => this.forUser, () => {
      this.currentlyPickedUserInfo = !this.forUser ? null : this.users.find(user => user.id === this.forUser);
    });

    this.sendVacationPositions = {};

    if (localStorage.getItem('roedl-dark-background')) {
      document.querySelector('body').classList.add('darkerBackground');
    }

    this.users = null;
    this.currentUserForVacation = null;

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel(timeout);});

        if(!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then( newUserInfo => {
            this.user = newUserInfo;
            this.overtimeManagement = !!this.user.preferences.featureFlags.find(f => f == "OvertimeManagement");
            this.powerUserFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "PowerUser");
            this.vacationReportingFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "VacationReporting");
            this.hasProjectsFlag = this.user.preferences.featureFlags.some(f => f == "ProjectsSetManually" || f == "ProjectsFromErpSystem");
            this.hasPartTimeVacationFlag = !!this.user.preferences.featureFlags.find(f => f == "PartTimeVacation");
          });
        } else {
          this.overtimeManagement = !!this.user.preferences.featureFlags.find(f => f == "OvertimeManagement");
          this.powerUserFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "PowerUser");
          this.vacationReportingFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "VacationReporting");
          this.hasProjectsFlag = this.user.preferences.featureFlags.some(f => f == "ProjectsSetManually" || f == "ProjectsFromErpSystem");
          this.hasPartTimeVacationFlag = !!this.user.preferences.featureFlags.find(f => f == "PartTimeVacation");
        }

        this.refreshSummary(); // here this.state = "loaded" set

        this.Auth.getFeatureFlags().then(resp=> {
          //this.hasProjectsFlag to to samo nie było czasu poprawić, sprawdzić - takie jest życie
          this.hasProjectsAllowed = resp.data.some( flag => flag === "ProjectsSetManually" || flag === "ProjectsFromErpSystem");
        },
        (error) => {
          this.error = error;
          this.state = "error";
        });

        this.Stats.getPowerUserStatus().then(
          (success) => {
            let daysReported = success.data.daysWithReportedTimePercentageOver95;
            let daysNeeded = success.data.neededDaysWithReportedTimePercentageOver95;
            let areDaysWithOver95MoreThanNeeded = daysReported >= daysNeeded;
            this.neededDaysWithReportedTimePercentageOver95 = daysNeeded;
            this.daysWithReportedTimePercentageOver95 = daysReported;
            this.longTermUser = {
              status: areDaysWithOver95MoreThanNeeded,
              value: areDaysWithOver95MoreThanNeeded ? 0 : 100 - (daysReported * 100 / daysNeeded),
              banner: daysReported == daysNeeded
            };
            this.hasAllDaysInThisMonthWithReportedTimePercentageOver95 = success.data.hasAllDaysInThisMonthWithReportedTimePercentageOver95;
            let streakCount = success.data.thisMonthStreakCount;
            let workingDays = success.data.thisMonthWorkingDaysCount;
            let thisMonthStreakValue = workingDays == 0 ? 0 : (streakCount / workingDays * 100);
            this.thisMonthStreakValueIcon = thisMonthStreakValue >= 100 ? 0 : (100 - thisMonthStreakValue);
            this.statePowerUser = "loaded";
          },
          (error) => {
            this.error = error;
            this.state = "error";
          }
        );

        this.Stats.getVacationProcesses().then(
          (vacationProcesses) => {
            this.internalProjectName = vacationProcesses.data.internalProjects || [];
            this.allVacationProcesses = vacationProcesses.data.vacations.sort(this.Sort.abcBy("processName"));
            this.vacationProcesses = this.allVacationProcesses.filter( v => !v.isArchived);
            this.getCalendarData().then(
              () => {
                this.recalculateCalendar('curr');
                this.thisMonthData = this.daysToGoStats;
              },
              (error) => {
                this.Notes.postNote({type: "error", description: "ERROR_LOADING_DATA", error: error, message: error.data && error.data.message});
                this.error = error;
              }
            );
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", description: "ERROR_LOADING_DATA", error: error});
            this.error = error;
          }
        );

        this.getPosition();

        this.Stats.getUsersForVaction({
          from: moment().add(1, 'days').format("YYYY-MM-DD"),
          to: moment().add(1, 'days').format("YYYY-MM-DD")
        }).then(({ data }) => {
            this.users = data;
            this.forUser = this.user.id;
          })
          .catch(err => {
            this.state = "error";
            this.error = err;
          });
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  getCalendarData() {
    const from = angular.copy(this.pickedDate).subtract(1, 'month').startOf('month').format("YYYY-MM-DD");
    const to = angular.copy(this.pickedDate).add(1, 'month').endOf('month').format("YYYY-MM-DD");
    let promises = [];
    if(this.vacationReportingFeatureFlag){
      promises = [
        this.Stats.getUserMonthlySummary(this.pickedDate.format("YYYY-MM")),
        this.Stats.getVacation(from,to)
      ];
    } else {
      promises = [
        this.Stats.getUserMonthlySummary(this.pickedDate.format("YYYY-MM")),
      ];
    }
    var defer = this.$q.defer();
    this.$q.all(promises).then(
      (success) => {
        this.userMonthlySummary = {
          prev: success[0].data[0],
          curr: success[0].data[1],
          next: success[0].data[2]
        };

        this.allVacationDays = [];
        if(this.vacationReportingFeatureFlag) {

          this.allVacationGroupped = this.getAllVacationGroupped();

          this.allVacationDays = this.allVacationGroupped.map( group => {
            // group is an array allVacationGroupped = [[group][group]]
            return group.map( g => {
              return {
                ...g,
                from: moment(group[0].dayFormatted).format("DD.MM.YYYY"),
                to: moment(group[group.length - 1].dayFormatted).format("DD.MM.YYYY")
              };
            });
          }).reduce((acc,curr)=>{
            return acc.concat(curr);
          },[]);
        }

        this.calendarGOTOButtonsState = "loaded";
        return defer.resolve(success);
      },
      (error) => {
        return defer.reject(error);
      }
    );

    return defer.promise;
  }

  recalculateCalendar(param) {
    this.calendarDays = this.getDaysArray(this.pickedDate)
    .map( (d) => {
      const userMonthlySummaries = this.userMonthlySummary[param].workdaySummaries;
      const index = userMonthlySummaries.findIndex( ums => moment(d.dayDisplayed, "DD.MM.YYYY").isSame(moment(ums.day, "YYYY-MM-DD")) );

      const day = this.userMonthlySummary[param].workdaySummaries[index];

      const vacation = day && day.isVacation && this.allVacationDays.find( v => moment(v.dayFormatted).isSame(moment(d.dayDisplayed, "DD.MM.YYYY"),'d'));

      const reportedTimeSek = day && moment.duration(day.reportedTime) / 1000; // in seconds
      const expectedWorknormSek = day && moment.duration(day.expectedWorknorm) / 1000; // in seconds
      const usedCumulatedOvertimeSek = day && day.usedCumulatedOvertime ? moment.duration(day.usedCumulatedOvertime) /1000 : 0; // in seconds , if overtimeFeatureFlag is disabled this field is 0

      let powerUserStreakStat = (reportedTimeSek + usedCumulatedOvertimeSek) * 100 / expectedWorknormSek;

      let reportedStats = 100;
      let overtimeStats = 0;
      let usedOvertimeStats = 0;
      const maxWorknorm = 28800; // 8h
      if(expectedWorknormSek == 0) {
        reportedStats = 0;
        usedOvertimeStats = 0;
        overtimeStats =  Math.round(reportedTimeSek * 100 / maxWorknorm);
      } else if(reportedTimeSek <= expectedWorknormSek) {
        reportedStats = Math.round(reportedTimeSek * 100 / expectedWorknormSek);
        usedOvertimeStats = Math.round( (usedCumulatedOvertimeSek * 100 / expectedWorknormSek) *100 ) /100;
        overtimeStats = 0;
      } else if (reportedTimeSek > expectedWorknormSek) {
        reportedStats = 100;
        usedOvertimeStats = 0;
        overtimeStats = Math.round((reportedTimeSek - expectedWorknormSek)/expectedWorknormSek * 100);
      }

      let isPartTimeVacation;

      if(this.hasPartTimeVacationFlag && day) isPartTimeVacation =
        moment(this.$filter("hms")(day.reportedTime), "HH:mm:ss").valueOf() < moment(this.$filter("hms")(day.expectedWorknorm), "HH:mm:ss").valueOf();
      else isPartTimeVacation = false;

        let dayInfo = {
        ...d,
        day: day && day.day,
        isHoliday: day &&  day.isHoliday,
        isVacation: day && day.isVacation,
        expectedWorknorm: day &&  day.expectedWorknorm,
        positionType: day && day.positionType,
        reportedTime: day && day.reportedTime,
        usedCumulatedOvertime: day && day.usedCumulatedOvertime,
        overtimeTime: reportedTimeSek && moment.duration(reportedTimeSek - expectedWorknormSek , 's').toJSON(),
        reportedStats: day && moment(day.day).isSameOrBefore(this.today.format("YYYY-MM-DD")) && reportedStats,
        overtimeStats: day && moment(day.day).isSameOrBefore(this.today.format("YYYY-MM-DD")) && overtimeStats,
        usedOvertimeStats: day && moment(day.day).isSameOrBefore(this.today.format("YYYY-MM-DD")) && usedOvertimeStats,
        powerUserStreakStat: day && moment(day.day).isSameOrBefore(this.today.format("YYYY-MM-DD")) && powerUserStreakStat,
        vacationFrom: vacation && vacation.from,
        vacationTo: vacation && vacation.to,
        vacationProcess: vacation && vacation.procName,
        vacationInfo: this.allVacationDays.filter( (x) => moment(day.day, "YYYY-MM-DD").isBetween(x.start, x.end, null, '[]'))[0],
        isPartTimeVacation: isPartTimeVacation,
        applicationOvertime : day && day.applicationOvertime
      };
      return dayInfo;
    });

    //days with isVacation flag are considered as workDay
    const workDays = this.calendarDays.filter( day => (moment.duration(day.expectedWorknorm) != 0)).length;
    const workDaysTillToday = this.calendarDays.filter( day => (moment.duration(day.expectedWorknorm) != 0) && moment(day.day).isBefore(this.today, 'day') ).length;

    this.daysToGoStats = {
      workDays,
      workDaysTillToday,
      daysToGo: workDays - workDaysTillToday
    };
  }

  getAllVacationGroupped() {
    return this.allVacationDays.reduce( (acc, curr) => {
      if(acc.length == 0) {
        acc.push([curr]);
      }
      else {
        const last = acc[acc.length - 1];
        const lastItem =  last[last.length - 1];

        let isNextWorkDay = moment(curr.dayFormatted).subtract(1, 'd').isSame(moment(lastItem.dayFormatted), 'd');

        const isSameProcess = curr.procId == lastItem.procId;

        if(isNextWorkDay && isSameProcess ) {
          last.push(curr);
          acc.slice(0, -1).push(last);
        }
        else {
          acc.push([curr]);
        }
      }

      return acc;
    }, []);
  }

  getDaysArray(originalDate) {
    const date = angular.copy(originalDate).startOf('month');
    const result = [];
    const startOfPresentWeek = angular.copy(this.today).startOf('week').add(1,'day');
    const endOfPresentWeek = angular.copy(this.today).endOf('week').add(1,'day');
    while (date.month() == originalDate.month()) {
      let x = {
        dayNumber: date.date(), // use to display on calendar
        dayDisplayed: date.format("DD.MM.YYYY"),
        weekend: date.day() == 6 || date.day() == 0, // use to color weekends
        weekDay: date.format("dddd"),
        isToday: this.today.isSame(moment(date), 'day'), // use to mark today
        isBeforeToday: moment(date).isBefore(this.today, 'day'), // use to show pu stats strips
        showOnSmallScreen: date.isBetween(startOfPresentWeek,endOfPresentWeek,null,'[]'), // use to show only current week on small screen
        isFuture: this.today.isBefore(moment(date), 'day'),
        clicked:  this.pickedDate.isSame(moment(date), 'day') ? true : false
      };
      result.push(x);
      date.add(1,'day');
    }
    return result;
  }

  handleDayDetails(day) {
    if(this.error && this.error.data && this.error.data.message && this.error.data.message.indexOf("VacationReporting") >= 0 ) {
      this.Notes.postNote({type: "error", description: "ERROR_LOADING_DATA", error: this.error, message: this.error.data.message});
    } else {
      this.pickedDate = moment(day.day);
      this.calendarDays = this.calendarDays.map( d => {
        if(day.day == d.day){
          return {...d , clicked: true};
        } else {
          return {...d , clicked: false};
        }
      });

      if(this.vacationReportingFeatureFlag && day.isVacation){
        this.showModal = 'vacation';
        this.deleteVacationValues = {
          from: day.day,
          to: moment(day.vacationTo, "DD.MM.YYYY").format("YYYY-MM-DD"),
          vacationInfo: day.vacationInfo
        };
      }
      else if (day.isHoliday) {
        this.showModal = 'holiday';
      }
      else {
        this.showModal = 'workingDay';
        this.newVacationValues = {
          forUser: this.forUser,
          from: day.day,
          to: day.day,
          processGroupConfigurationId: this.vacationProcesses[0] && this.vacationProcesses[0].processGroupConfigurationId
        };
      }

      this.dayDetails = {...day};
    }
  }

  goToMonth(param) { // use on buttons < > ('prev' and 'next')
    this.calendarGOTOButtonsState = "loading";
    if(param == 'prev') {
      this.pickedDate.startOf('month').subtract(1, 'months');
    }
    if(param == 'next') {
      this.pickedDate.startOf('month').add(1, 'months');
    }
    this.year = this.pickedDate.format("YYYY");
    this.monthName = this.pickedDate.format("MMMM");

    this.recalculateCalendar(param);
    this.getCalendarData();
    this.state = "loaded";
  }

  exportData() {
    this.state = "loading";
    this.dateStart = moment(this.dateStartChoice);
    this.dateEnd = moment(this.dateEndChoice);
    return this.Stats.export(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD"), "user").then((success) => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
          success,
          success.headers("content-type"),
          `klix-${this.dateStart.format("YYYY-MM-DD")}-${this.dateEnd.format("YYYY-MM-DD")}-${moment().format("HH:mm")}.xlsx`
          );
    }, (error) => {
      this.error = error;
      this.state = 'error';
    });
  }

  deserializeSummary(summaryData) {
    var summary = angular.copy(summaryData);

    summary.toShow = {
      reportedTime: roundTimeSeconds(summary.reportedTime),
      time: roundTimeSeconds(summary.time),
      reportedOvertime: roundTimeSeconds(summary.reportedOvertime),
      acceptedOvertime: roundTimeSeconds(summary.acceptedOvertime),
      cumulatedOvertime: roundTimeSeconds(summary.cumulatedOvertime),
    };

    summary.reportedTimeMoment = moment.duration(summary.reportedTime);
    summary.timeMoment = moment.duration(summary.time);
    summary.percent = Math.min(100, summary.reportedTimeMoment.asSeconds() / summary.timeMoment.asSeconds() * 100);
    summary.enough = summary.percent > 95;
    if(summary.percent != summary.percent){
      summary.percent = 0;
    }

    summary.perClientReported.map((client) => {
      client.timeMoment = moment.duration(client.time);
      client.seconds = client.timeMoment.asSeconds();
      client.noProjectTime = client.noProjectTime && client.noProjectTime !== 'PT0S' ? moment.duration(client.noProjectTime) : undefined;
      client.projectsWithTimeReported = client.projectsWithTimeReported.map(p => ({...p, timeMoment: moment.duration(p.time) }));

      if (client.additionalInfo)
        client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.clientName}`;
    });

    summary.perClientProcessGroupReported.map((client) => {
      client.perProcessGroup.map((pg) => {
        pg.timeMoment = moment.duration(pg.time);
        pg.seconds = pg.timeMoment.asSeconds();
        pg.itemName = pg.processGroupName;
        pg.noProjectTime = pg.noProjectTime && pg.noProjectTime !== 'PT0S' ? moment.duration(pg.noProjectTime) : undefined;
        pg.projectsWithTimeReported = pg.projectsWithTimeReported.map(p => ({...p, timeMoment: moment.duration(p.time) }));
      });
      client.items = client.perProcessGroup;
    });

    summary.perClientInterruptReported.map((ci) => {
      ci.perInterrupt.map((i) => {
        i.timeMoment = moment.duration(i.time);
        i.seconds = i.timeMoment.asSeconds();
        i.itemName = i.interruptName;
        i.noProjectTime = i.noProjectTime && i.noProjectTime !== 'PT0S' ? moment.duration(i.noProjectTime) : undefined;
        i.projectsWithTimeReported = i.projectsWithTimeReported.map(p => ({...p, timeMoment: moment.duration(p.time) }));
      });
      ci.items = ci.perInterrupt;
      if(summary.perClientProcessGroupReported.some((x) => x.clientName == ci.clientName)) {
        var client = summary.perClientProcessGroupReported.filter((x) => x.clientName == ci.clientName)[0];
        client.items = client.items.concat(ci.perInterrupt);
      } else {
        summary.perClientProcessGroupReported.push(ci);
      }
    });
    return summary;
  }

  refreshSummary() {
    this.dateStart = moment(this.dateStartChoice);
    this.dateEnd = moment(this.dateEndChoice);
    this.state = "loading";
    return this.Stats.getSummary(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD"), "user").then((success) => {
      this.summary = this.deserializeSummary(success.data);
      this.state = "loaded";
    }, (error) => {
      this.state = "error";
      this.error = error;
    });
  }

  refreshPowerUser() {
    this.statePowerUser = "loading";
    let todayMonth = moment(this.dateToday);
    this.Stats.getPowerUser(todayMonth.format("YYYY-MM")).then((success) => {
      let powerUserRefreshStatus = success.data.isPowerUser;
      if (powerUserRefreshStatus) {
        this.statePowerUser = "loaded";
        this.Notes.postNote({
          type: "success",
          success: success,
          message: this.$translate.instant('WORK_DATA.POWER_USER.POWER_USER_REFRESH_GRANTED')
        });
        this.Auth.getFreshUserCredentials(true).then(
          () => this.$route.reload()
        );
      } else {
        this.statePowerUser = "loaded";
        this.Notes.postNote({
          type: "success",
          success: success,
          message: this.$translate.instant('WORK_DATA.POWER_USER.POWER_USER_REFRESH_FAIL')
        });
      }
    }, (error) => {
      this.statePowerUser = "loaded";
      this.state = "error";
      this.error = error;
    });
  }

  updateDates(values) {
    this.dateStart = moment(values[0]);
    this.dateEnd = moment(values[1]);

    this.dateStartChoice = this.dateStart.format("YYYY-MM-DD");
    this.dateEndChoice = this.dateEnd.format("YYYY-MM-DD");

    this.refreshSummary();
  }

  handleVacation() {
    this.setRadioToFullVacation();
    if (this.currentlyPickedUserInfo && !this.currentlyPickedUserInfo.onLongTermLeave) {
      this.newVacationValues = {
        from: moment().add(1, 'days').format("YYYY-MM-DD"),
        to: moment().add(1, 'days').format("YYYY-MM-DD"),
        processGroupConfigurationId: this.vacationProcesses[0] && this.vacationProcesses[0].processGroupConfigurationId
      };
      this.newVacationProcess = true;
    }
  }

  setRadioToFullVacation(){
    this.pickType = "0";
  }

  addNewVacation() {

    function makeDuration(vacationPosition) {
      const duration = moment.duration(vacationPosition, "hours").toJSON();
      return duration;
    }
      this.newVacationProcess = false;
      this.showAddVacationForm = false;
      this.showModal = undefined;
      this.state = "loading";
      this.newVacationValuesInvalid = undefined;
      this.newVacationValues.type = "SickLeave";

      if (this.tempUsersBasicInfo) {
        this.users = angular.copy(this.tempUsersBasicInfo);
        this.tempUsersBasicInfo = null;
      }

      if (this.pickType == 0) {
        this.newVacationValues.vacationEntries =
          {
            percentage: 100, //full time vacation
            hoursByWeekday: {}
          };
      }
      if (this.pickType == 1) {
        this.sendVacationPositions = {
          MONDAY: makeDuration(this.vacationPositions[0]),
          TUESDAY: makeDuration(this.vacationPositions[1]),
          WEDNESDAY: makeDuration(this.vacationPositions[2]),
          THURSDAY: makeDuration(this.vacationPositions[3]),
          FRIDAY: makeDuration(this.vacationPositions[4]),
        };
        this.newVacationValues.vacationEntries = {
          percentage: null, //bo w scali Option[Int] pato
          hoursByWeekday: this.sendVacationPositions
        };
      }

      if (this.pickType == 2) {
        this.newVacationValues.vacationEntries =
          {
            percentage: this.vacationPercentage,
            hoursByWeekday: {}
          };
      }

      const data = {
        forUser: this.forUser,
        from: this.newVacationValues.from,
        to: this.newVacationValues.to
      };

      if (this.currentlyPickedUserInfo.onWorknorm) {
        data.processClientConfigurationId = this.newVacationValues.processGroupConfigurationId;
        data.projectId = this.newVacationValues.internalProject;
        data.type = this.newVacationValues.type;
        data.vacationEntriesMode = this.newVacationValues.vacationEntries;
        data.zoneId = moment.tz.guess();
      }

      this.Stats.addNewVacation(data).then(
        (success) => {
          this.getCalendarData().then(
            () => {
              this.recalculateCalendar('curr');
              this.state = "loaded";
            },
            () => {}
          );
          if (this.currentlyPickedUserInfo.onWorknorm) {
            if (success.data.daysWithExceededTime.length > 0) {
              this.warningModalExceededTime = true;
              this.warningModalExceededTimeData = success.data.daysWithExceededTime;
              this.showModal = 'warning';
            }
            else if(success.data.entries.length === this.daysToSubmit)
              this.Notes.postNote({type: "success", success: success, message: success.data.message });
            else
              this.Notes.postNote({type: "success", success: success, message: success.data.message});
          } else
            this.Notes.postNote({type: "success", success: success, message: success.data.message });
        },
        (error) => {
          this.state = 'loaded';
          if (error.data && error.data.message) {
            const errorMessage =
              error.data.message.includes('List(VacationEntriesOverlap)') || error.data.message.includes('List(VacationsOverlap)')
                ? 'Vacations in the specified range already exist'
                : error.data.message;
            this.Notes.postNote({type: "error", error: error, message: errorMessage});
          }
        }
      ).finally(() => this.forUser = this.user.id);
  }

  deleteVacation() {
    this.showModal = undefined;
    this.showDeleteForm = false;
    this.state = "loading";
    let from = this.deleteVacationValues.from;
    let to = this.deleteVacationValues.to;

    this.Stats.deleteVacation(from, to).then(
      () => {
        this.getCalendarData().then(
          () => {
            this.recalculateCalendar('curr');
            this.state = "loaded";
          },
          () => {}
        );
        this.Notes.postNote({type: "deleted"});
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );

    this.forUser = this.user.id;
  }

  cancel() {
    this.showModal = undefined;
    this.newVacationProcess = false;
    this.showDeleteForm = false;
    this.showAddVacationForm = false;
    this.newVacationValuesInvalid = undefined;
    this.warningModalExceededTime = undefined;
    if (this.tempUsersBasicInfo) {
      this.users = angular.copy(this.tempUsersBasicInfo);
      this.tempUsersBasicInfo = null;
    }
    this.forUser = this.user.id;
  }

  goToDate(day) {
    this.showModal = undefined;
    this.dateStart = moment(day.day);
    this.dateEnd = moment(day.day);
    this.dateStartChoice = moment(day.day);
    this.dateEndChoice = moment(day.day);
    this.refreshSummary();
  }

  getPosition(){
    this.Stats.getPosition().then(
      (success) => {
        this.userPosition = success.data;
        this.userPosition.worknorms.map((worknorm, index) => {
          this.vacationPositions[index] = worknorm;
      });
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error, message: error.data && error.data.message});
      }
    );
  }

  clickDelete(){
    this.showDeleteForm = true;
    if(this.deleteVacationValues.to === "Invalid date"){
      this.deleteVacationValues.to = this.deleteVacationValues.from;
    }

  }

  showDate() {
    if(this.newVacationValues.from !== null && this.newVacationValues.to !== null){
      let from = moment(this.newVacationValues.from);
      let to = moment(this.newVacationValues.to);

      this.daysToSubmit = 0;

      this.weekdaysForSelectHours = {
        MONDAY: false,
        TUESDAY: false,
        WEDNESDAY: false,
        THURSDAY: false,
        FRIDAY: false,
      };

      for (from; from.isSameOrBefore(to); from.add(1, 'days')) {
        if(from.isoWeekday() === 1) {
          this.weekdaysForSelectHours.MONDAY = true;
          this.daysToSubmit++;
        }
        if(from.isoWeekday() === 2) {
          this.weekdaysForSelectHours.TUESDAY = true;
          this.daysToSubmit++;
        }
        if(from.isoWeekday() === 3) {
          this.weekdaysForSelectHours.WEDNESDAY = true;
          this.daysToSubmit++;
        }
        if(from.isoWeekday() === 4) {
          this.weekdaysForSelectHours.THURSDAY = true;
          this.daysToSubmit++;
        }
        if(from.isoWeekday() === 5) {
          this.weekdaysForSelectHours.FRIDAY = true;
          this.daysToSubmit++;
        }
      }
    }
  }

  getUsersInfo() {
    this.loadingUsersWorkingInfo = 'loading';
    if (!this.tempUsersBasicInfo)
      this.tempUsersBasicInfo = angular.copy(this.users);

    this.Stats.getUsersForVaction({
      from: this.newVacationValues.from,
      to: this.newVacationValues.to
    }).then(({ data }) => {
        this.users = data;
        this.loadingUsersWorkingInfo = 'loaded';
        this.currentlyPickedUserInfo = !this.forUser ? null : this.users.find(user => user.id === this.forUser);
      })
      .catch(err => {
        this.state = "error";
        this.error = err;
        this.loadingUsersWorkingInfo = 'error';
      });
  }
}
